module.exports = __webpack_public_path__ + "img/logo-gau.9fe3587a.png";